import { useQuery } from "@tanstack/react-query";
import { getDriverDetails } from "../../../hooks/use-driver";

export function useDriverDetails(driverId, partnerId) {
  const query = useQuery({
    queryKey: ["driverDetails", driverId, partnerId],

    queryFn: () => getDriverDetails(driverId, partnerId),

    enabled: Boolean(driverId && partnerId),

    staleTime: 60 * 1000,

    gcTime: 5 * 60 * 1000,

    retry: false,

    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    driverDetails: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
